function thisExpression(tc_this = {}, pb_this = {}) {
  return tc_this.type === pb_this.type;
}

export default thisExpression;